import React from "react";
import { QuoteIcon, StarIcon } from "lucide-react";
import { testimonials } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { TransformCta } from "../ui/TransformCta";
export function Testimonials() {
  return <section className="bg-brand-50 px-5 py-16 sm:py-24" aria-labelledby="testimonials-title" data-id="element-283" data-mp="3meplsx31m3t1">
      <div id="testimonials-title" data-id="element-284" data-mp="3r9lnyq1zu7jv">
        <SectionHeading title={<>
              What other students <em className="italic text-brand-600" data-id="element-286" data-mp="42t2rb9y6roi">are saying</em>
            </>} subtitle="From scattered information to an organized practice." data-id="element-285" data-mp="1r0smonc1iu" />
      </div>

      <div className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-5 md:grid-cols-2" data-id="element-287" data-mp="9030de7hq9nf">
        {testimonials.map(t => <figure key={t.quote} className="flex flex-col rounded-3xl bg-white p-6 shadow-sm ring-1 ring-brand-100 sm:p-8" data-id="element-288" data-mp="2atiskfj87wki">
            <div className="flex items-center justify-between" data-id="element-289" data-mp="2ftew6do0hlzj">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-290" data-mp="1skj3qb1t6xkf">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-291" data-mp="1nsrkymow9w4u" data-mpi={i} />)}
              </div>
              <QuoteIcon className="h-8 w-8 text-brand-200" aria-hidden="true" data-id="element-292" data-mp="1iuzmtaxnpds7" />
            </div>
            <blockquote className="mt-4 font-serif text-xl font-bold leading-snug text-ink" data-id="element-293" data-mp="1euz2xarsgadr">“{t.quote}”</blockquote>
            <figcaption className="mt-auto flex items-center gap-4 pt-6" data-id="element-294" data-mp="2bh123bb5xvpn">
              <img src={t.photo} alt={t.name} className="h-14 w-14 rounded-full object-cover ring-2 ring-brand-200" loading="lazy" data-id="element-295" data-mp="26l3m563tarde" />
              <div data-id="element-296" data-mp="1xjm8dudvn1rv">
                <p className="font-extrabold text-ink" data-id="element-297" data-mp="1xk5hclljuftr">{t.name}</p>
                <p className="text-sm text-ink/60" data-id="element-298" data-mp="1xlymtxkfeu06">{t.country}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>

      <TransformCta label="I want my Reflexology 360° system" data-id="element-299" data-mp="m3fftfs2mc6h" />
    </section>;
}